import { z } from 'zod';

import {
  MAX_CHARACTERS_REASON_FOR_VISIT,
  REASON_FOR_VISIT_REGEX,
  StepOneFormKeys,
} from './constants';

type TranslationFunction = (key: string, values?: Record<string, string | number>) => string;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const stepOneSchema = (t: TranslationFunction) => {
  return z
    .object({
      [StepOneFormKeys.selfPayor]: z
        .string()
        .trim()
        .min(1, { message: t('OAS.Booking.Errors.SelfPayor') || 'Please select a self payor' }),
      [StepOneFormKeys.newPatient]: z
        .string()
        .trim()
        .min(1, {
          message: t('OAS.Booking.Errors.AppointmentType') || 'Please select an appointment type',
        }),
      [StepOneFormKeys.appointmentType]: z.string().trim(),
      [StepOneFormKeys.reasonForVisit]: z
        .string()
        .trim()

        .max(MAX_CHARACTERS_REASON_FOR_VISIT, {
          // Todo: add translation
          // t('OAS.Booking.Errors.MaxCharactersReasonForVisit', {
          // number: MAX_CHARACTERS_REASON_FOR_VISIT,
          // }),
          message: `
          Please reduce your Reason for Visit to ${MAX_CHARACTERS_REASON_FOR_VISIT} characters or less`,
        })
        .min(1, {
          message: t('OAS.Booking.Errors.MinCharacters') || 'Please type a reason for visit',
        })
        .regex(REASON_FOR_VISIT_REGEX, {
          message:
            t('OAS.Booking.Errors.ReasonForVisitFormatError') ||
            "Reason for Visit may not include special characters other than ' ? . , & or -",
        }),
    })
    .refine(
      (data) => {
        if (data[StepOneFormKeys.newPatient] === '0') {
          return (
            data[StepOneFormKeys.appointmentType] &&
            data[StepOneFormKeys.appointmentType] !== 'select'
          );
        }
        return true; // No validation needed if not "No"
      },
      {
        message: t('OAS.Booking.Errors.AppointmentType') || 'Please select an appointment type',
        path: [StepOneFormKeys.appointmentType], // attach the error to the right field
      }
    );
};

export type StepOneFormData = z.infer<ReturnType<typeof stepOneSchema>>;
